import { IFetchObject } from '../../data/actions.interface'
import { IPowerbiSettingsDto } from './settings.dto'

export const getSettings = (): IFetchObject => ({
    key: 'settings',
    url: 'settings',
    method: 'GET',
    default: {},
})

/**
 * Deliberately a different cache key than getSettings: sharing one would flip
 * the 'settings' entry to 'fetching' while saving and unmount the form.
 */
export const updateSettings = (settings: IPowerbiSettingsDto): IFetchObject => ({
    key: 'update-settings',
    url: 'settings',
    method: 'PUT',
    default: {},
    body: settings,
})
